<template>
    <div class="logo-on zhss">
        <!--身份证被注册-->
        <router-link tag="a" to="/sign-up/account-appeal/id" class="registered-a">
            <img src="~@public/img/signup/sfz_icon.png">
            <p>身份证被他人手机号注册</p>
        </router-link>
        <!--手机号被注册-->
        <router-link tag="a" to="/sign-up/account-appeal/tel" class="registered-a">
            <img src="~@public/img/signup/tel_icon.png">
            <p>手机号被他人身份证注册</p>
        </router-link>

        <div class="tips">
            <div class="tips-img tips-img-tel">
                <p>本服务由湖北省统一认证平台提供</p>
                <p>咨询服务热线:<span class="font36">12345</span></p>
            </div>
        </div>

    </div>
</template>

<script>
    import { CellGroup, Field} from 'vant'

    export default {
        name: "AccountAppeal",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
        },
        data(){
            return{

            }
        },
        methods:{
            nextTips(){
                this.$router.push({ path:'/sign-up/forgetpassword/det'});
                this.tips=true;
            }
        }
    }
</script>

<style scoped>
    @import "~@assets/css/public/signup.css";
    .zhss{overflow: hidden}
    .registered-a{
        width:100%;
        background:rgba(255,255,255,1);
        box-shadow:0 3px 10px 0 rgba(72,129,231,0.2);
        border-radius:10px;
        font-size: 30px;
        color: #000;
        text-align: center;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        padding: 50px 0 30px 0;
    }
    .registered-a:nth-child(1){margin-top: 80px}
    .registered-a:nth-child(2){margin-top: 40px}
    .registered-a img{height: 158px;display: block}
    .registered-a p{padding-top: 30px;font-size: 30px;width: 100%}


</style>
